@let isNew =
  appPagesEc.plugins.currentEntityPlugin.feature.selectors
    .isCreating()
    .asSignal();

@if (
  appPagesEc.plugins.currentEntityPlugin.feature.selectors
    .getEditedEntity()
    .asSignal();
  as appPage
) {
  @let submissionError =
    appPagesEc.plugins.editingPlugin.feature.selectors.submissionError.asSignal();
  <atn-ds-centered-overlay>
    <atn-ds-widget [title]="isNew ? 'Create App Page' : 'Update App Page'">
      <i
        actions
        class="atn-icon atn-close atn-red"
        (click)="cancelClickHandler()"
      ></i>
      <div class="atn-admin-app__content">
        <atn-ds-text
          label="Name"
          placeholder="Enter a name"
          [value]="appPage.name"
          (change)="updateAppPage('name', $event ?? '')"
        ></atn-ds-text>
        <!-- TODO: We should find a way to enforce uniquness here. -->
        <atn-ds-text
          label="Alias"
          placeholder="Enter an alias"
          [value]="appPage.alias"
          (change)="updateAppPage('alias', $event ?? '')"
        ></atn-ds-text>
        <atn-ds-text
          label="Description"
          placeholder="Enter a description"
          [value]="appPage.description"
          (change)="updateAppPage('description', $event ?? '')"
        ></atn-ds-text>
        <atn-ds-select-single-ec
          label="Page"
          [collection]="pagesEc"
          [config]="{
            overlay: {
              hasSearch: true,
            },
          }"
          [selectionTarget]="selectionTarget"
          descriptor="PageSelector.Overlay"
        />

        <atn-ds-toggle-button
          label="Is Visible?"
          [active]="!!appPage.display"
          (activeChange)="updateAppPageDisplayValue($event)"
        >
        </atn-ds-toggle-button>
        @if (appPage.display) {
          <atn-ds-checkbox
            label="Is Main?"
            [selected]="appPage.display.isMain"
            (selectedChange)="updateAppPageDisplayInfo('isMain', !!$event)"
          />
          <atn-ds-number
            label="Position"
            [value]="appPage.display.position"
            (change)="updateAppPageDisplayInfo('position', $event ?? 1)"
          />
        }
        <atn-admin-error-message [message]="submissionError" />
      </div>
      <div
        class="atn-admin-app__footer"
        footer
      >
        <atn-ds-button
          type="transparent"
          (click)="cancelClickHandler()"
        >
          Cancel
        </atn-ds-button>
        <atn-ds-button (click)="saveClickHandler()"> Save </atn-ds-button>
      </div>
    </atn-ds-widget>
  </atn-ds-centered-overlay>
}
